import raven from 'raven';
import { url } from './config/ravenConfig';
import { IS_SERVER, NODE_ENV, REVISION, BUILD, CONFIG_PROFILE} from './config';

let nodeSentryClient;

if (IS_SERVER) {
  nodeSentryClient = new raven.Client(url);
  // "This will cause any uncaught exception which would bubble up to the Node runtime to be captured and processed by Raven."
  nodeSentryClient.patchGlobal();
  nodeSentryClient.setTagsContext({
    environment: CONFIG_PROFILE,
    revision: REVISION,
    build: BUILD,
  });
}

export default function(exception, extra) {
  if (NODE_ENV !== 'production') return;

  const client = IS_SERVER ? nodeSentryClient : window.Raven;
  client.captureException(exception, { extra });
}

export { nodeSentryClient };



// WEBPACK FOOTER //
// ./src/universalSentryLog.js